import styled, { css } from "styled-components";
import Tag from "components/ui/Tag";
import { colors, mediaMax } from "utils/theme";
import { OnboardingState } from "types/onboarding";

const getStatusTagStyles = ({ $status }: { $status: OnboardingState }) => {
  switch ($status) {
    case OnboardingState.unregistered:
    case OnboardingState.confirmedEmail:
      return css`
        background: ${colors.flax};
      `;
    case OnboardingState.registered:
    case OnboardingState.linkedIncomeAccount:
    case OnboardingState.linkedCoreFinancialInstitutionAccount:
      return css`
        background: ${colors.heliotrope};
        color: white;
      `;
    case OnboardingState.onboarded:
    case OnboardingState.acceptedTermsAndConditions:
    case OnboardingState.submittedPersonalInformation:
    case OnboardingState.submittedIdentityVerification:
      return css`
        background: ${colors.azure};
        color: white;
      `;
    case OnboardingState.verifiedIdentity:
    case OnboardingState.switchedDirectDeposit:
    case OnboardingState.acknowledgedRepaymentAccount:
    case OnboardingState.acceptedRefundAdvance:
      return css`
        background: ${colors.violet};
        color: white;
      `;
    case OnboardingState.startedTaxReturn:
    case OnboardingState.submittedTaxReturn:
    case OnboardingState.taxReturnAccepted:
      return css`
        background: ${colors.clementine};
      `;
    case OnboardingState.issuedCard:
    case OnboardingState.activatedCard:
    case OnboardingState.usedCard:
      return css`
        background: ${colors.leaf};
      `;
    case OnboardingState.taxReturnRejected:
      return css`
        background: ${colors.cosmos};
      `;
    case OnboardingState.deactivated:
      return css`
        background: ${colors.cerise};
        color: white;
      `;
    default:
      return "";
  }
};

export const Wrapper = styled(Tag)<{ $status: OnboardingState }>`
  width: fit-content;

  color: ${colors.midnight};
  background: ${colors.flax};

  ${getStatusTagStyles}

  ${mediaMax("lg")} {
    margin-top: 6px;
  }
`;
